module.exports = __webpack_public_path__ + "img/ic_hub_error.1a963274.svg";